import React, { useEffect, useState } from 'react';
import PrizePopUp from './PopUp/PrizePopUp';
import { BingoApi } from '../../Utils/Api/BingoApi';
import { useAlert } from 'react-alert';
import { useLocation } from 'react-router-dom';
import { splitQuery } from '../../Shares/CommonUtil';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../Utils/atoms';
import { initUnity, setUnityMember } from '../../Utils/unityUtil';
import { EventApi } from '../../Utils/Api/EventApi';

const BingoMain = () => {
    const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;
	const alert = useAlert();
    const [member_se, setMemberSe] = useState(0);
    const [rewardResult, setRewardResult] = useState({});
    const [prizePopup, setPrizePopup] = useState(0);
	const [isLoading, setisLoading] = useState(false);
    const [countData, setCountData] = useState([]);
    const [rewardData, setRewardData] = useState([]);
    const [lineData, setLineData] = useState([]);
    const [lineCount, setLineCount] = useState([]);
    const [boardData, setBoardData] = useState([]);
    const [boardCount, setBoardCount] = useState(0);
    
    // 주소에서 event_se 가져오기
	const { search } = useLocation();
	const querys = splitQuery(search);
	const event_se = querys['event_se'] ? querys['event_se'] : 0;

    // 믹스패널용 이벤트 정보
	const [eventName, setEventName] = useState('');
	const [eventCategoryType, setEventCategoryType] = useState('');

	// member_se 호출에 실패했을 경우의 안내 팝업
	const showErrorAlert = (message) => {
		alert.error(message, {
			timeout: 5000, // 5 seconds
		});
	};

    // Unity 함수 호출MixPanelCompleteEvent 
	useEffect(() => {
		if (event_se > 0) {
			initUnity();
			setUnityMember(
				(member_se) => setMemberSe(member_se),
				(msg) => showErrorAlert(msg)
			);
		}
	}, []);

    // 카테고리 코드에 따른 카테고리 명을 반환한다
	const getEventCategoryName = (category_cd) => {
		let result = '';
		if (category_cd === 0) {
			result = '기본';
		} else if (category_cd === 1) {
			result = '룰렛';
		} else if (category_cd === 2) {
			result = '뽑기';
		} else if (category_cd === 3) {
			result = '빙고';
		}

		return result;
	};

    // GET 이벤트 상세 정보 API
	useEffect(() => {
		EventApi.GetEventStatus(event_se).then((response) => {
			const { status, data } = response;
			if (status === 200) {
				setEventName(data.data.event_nm);
				setEventCategoryType(
					getEventCategoryName(data.data.event_category_cd)
				);
			}
		})
		.catch(error => {
			const { status, data } = error.response;
			if (status === 404) {
				alert.error(data.msg, {
					timeout: 10000, // 10 seconds
				});
			}
		});
	}, [event_se]);

    // GET API 호출
	useEffect(() => {
		if (member_se > 0) {
            // GET 빙고 횟수
			BingoApi.GetBingoCount(event_se, member_se).then((response) => {
				const { status, data } = response;
				if (status === 200) {
					setCountData(data)
				}
			});
            // GET 빙고 칸/줄 데이터
            BingoApi.GetBingoCompleteState(event_se, member_se).then((response) => {
				const { status, data : { bingoState } } = response;
				if (status === 200) {
					setRewardData(bingoState.receivedRewards);
                    setLineData(bingoState.finishedLines);
                    setLineCount(bingoState.lineCount);
				}
			});
            // GET 빙고 판 보상 상태
            BingoApi.GetBingoBoard(event_se, member_se).then((response) => {
				const { status, data : { bingoBoardRewards, completedBoardCount } } = response;
				if (status === 200) {
					setBoardData(bingoBoardRewards);
                    setBoardCount(completedBoardCount);
				}
			});
		}
	}, [member_se]);
    
    // 버튼 상태 설정
    const buttonClass = () => {
        {/** 버튼 기본 형태는 start이며 비활성화 시 disabled 클래스, 새 빙고판 교체 시 chagne 클래스 사용 */}
        if (lineCount >= 4) {
            return 'btn change';
        } else if (countData.totalCount <= 0) {
            return 'btn disabled';
        } else {
            return 'btn';
        }
    };

    // 판 보상 상태 설정
    const stageClass = (state) => {
        {/** 스테이지 완료 시 success 클래스 추가, 활성화 된 스테이지는 on, 스테이지 완료 시 success 클래스 추가 */}
        if (state === 1) {
            return 'stage';
        } else if (state === 2) {
            return 'stage on';
        } else if (state === 3) {
            return 'stage on success';
        }
    };

    // 아이템 리스트
    const renderItems = () => {
        const items = [];

        {/** 획득 시 on 클래스 추가 */}
        for (let i = 1; i < 10; i++) {
            items.push(<div className={Object.values(rewardData).includes(i) ? 'items on' : 'items'} key={i}>item</div>);
        }
        return items;
    };

    // 판 보상 받기
    const handleBoardReward = (row) => {
        if (row.state_cd === 2) {
            try {
            // POST 빙고 판 보상 받기
            const data = { event_se: event_se, member_se: member_se, standard_cnt: row.standard_cnt };
            BingoApi.PostBingoBoardReward(data).then((response) => {
                const { status, data } = response;
                if (status === 200) {
                        //setRewardData(data.rewardInfo)
                    setPrizePopup(data.rewardInfo.reward_cn);
                    // GET 빙고 판 보상 상태 다시 불러오기
                    BingoApi.GetBingoBoard(event_se, member_se).then((response) => {
                        const { status, data : { bingoBoardRewards, completedBoardCount } } = response;
                        if (status === 200) {
                            setBoardData(bingoBoardRewards);
                            setBoardCount(completedBoardCount);
                        }
                    });
                }
            });
            } catch (error) {
              console.error("API 호출 에러:", error);
            }
        }
    };

    // 버튼 클릭
    const handleButtonClick = async () => {
        if (isLoading) {
			return;
		}
		if (member_se > -1) {
			setisLoading(true);
            const data = { event_se: event_se, member_se: member_se };
            // 4줄 이상 완성했을때 빙고판 교체
            if (lineCount >= 4) {
                await BingoApi.PostNewBingoBoard(data).then((response) => {
                    const { status, data } = response;
                    if (status === 200) {
                        // GET 빙고 판 보상 상태 다시 불러오기
                        BingoApi.GetBingoBoard(event_se, member_se).then((response) => {
                            const { status, data : { bingoBoardRewards, completedBoardCount } } = response;
                            if (status === 200) {
                                setBoardData(bingoBoardRewards);
                                setBoardCount(completedBoardCount);
                            }
                        });
                        // GET 빙고 칸/줄 데이터 다시 불러오기
                        BingoApi.GetBingoCompleteState(event_se, member_se).then((response) => {
                            const { status, data : { bingoState } } = response;
                            if (status === 200) {
                                setRewardData(bingoState.receivedRewards);
                                setLineData(bingoState.finishedLines);
                                setLineCount(bingoState.lineCount);
                            }
                        });
                    }
                });
            }
            // 빙고 시작
            else if (countData.totalCount > 0) {
                await BingoApi.PostBingoStart(data).then((response) => {
                    const { status, data } = response;
                    if (status === 200) {
                        setRewardResult(data);
                        setCountData({
                            ...countData,
                            totalCount: countData.totalCount-1
                        });
                        window.MixPanelCompleteEvent(
                            eventName,
                            eventCategoryType,
                            rewardResult.event_reward_info_nm
                        );
                        // GET 빙고 칸/줄 데이터 다시 불러오기
                        BingoApi.GetBingoCompleteState(event_se, member_se).then((response) => {
                            const { status, data : { bingoState } } = response;
                            if (status === 200) {
                                setRewardData(bingoState.receivedRewards);
                                setLineData(bingoState.finishedLines);
                                setLineCount(bingoState.lineCount);
                            }
                        });
                    }
                });
            }
            setisLoading(false);
		}
    }

    return (
        <div className='wrap'>
            <div className='container'>
                <div className='content Bingo'>
                    <div className='visual'>
                        <h1>
                            <img src={`${IMG_URL}/images/bingo/title.png`} alt='레오의 빙고놀이' />
                        </h1>
                        <div className='date'>03.25 - 04.24</div>
                        <div className='bingo-box'>
                            <dl className='change-bingo'>
                                <dt>빙고 도전 기회</dt>
                                <dd>
                                    <span>{countData.totalCount}</span>/7회
                                </dd>
                            </dl>
                            <div className='bingo-area'>
                                {/* 아이템 리스트 */}
                                {renderItems()}
                                {/**
                                 * line 클래스를 갖는 요소들은 line diagonal, horizon, vertical는 기본 값이며 항상 존재해야 하는 클래스 입니다.
                                 * 해당 위치의 빙고가 활성화 될 경우 위치를 나타내는 top, middle, left, right, bottom의 클래스를 사용해주세요.
                                 */}
                                <div className={lineData[0] ? 'line horizon top' : 'line horizon'}></div>
                                <div className={lineData[1] ? 'line horizon middle' : 'line horizon'}></div>
                                <div className={lineData[2] ? 'line horizon bottom' : 'line horizon'}></div>
                                <div className={lineData[3] ? 'line vertical left' : 'line vertical'}></div>
                                <div className={lineData[4] ? 'line vertical middle' : 'line vertical'}></div>
                                <div className={lineData[5] ? 'line vertical right' : 'line vertical'}></div>
                                <div className={lineData[6] ? 'line diagonal left basic-left' : 'line diagonal basic-left'}></div>
                                <div className={lineData[7] ? 'line diagonal right basic-right' : 'line diagonal basic-right'}></div>
                            </div>
                            <dl className='complete-line'>
                                <dt>완성한 줄</dt>
                                <dd>
                                    <span>{lineCount}</span>/4줄
                                </dd>
                            </dl>
                            {member_se > 0 && (
                                <button
                                    className={buttonClass()}
                                    onClick={() => {
                                        window.MixPanelClickEventButton(
                                            eventName,
                                            eventCategoryType
                                        );
                                        handleButtonClick();
                                    }}
                                >
                                    btn
                                </button>
                            )}
                            {prizePopup !== 0 && (
                                <PrizePopUp
                                    close={() => setPrizePopup(0)}
                                    rewardCount = {prizePopup}
                                />
                            )}
                        </div>
                        <p className='tip'>4줄이 되면 빙고 한 판이 완성됩니다!</p>
                    </div>
                    <div className='event-info checked'>
                        <div className='tit-area'>
                            <h3>빙고 도전 가능 추가 횟수</h3>
                        </div> 
                        <ul className='get-coin'>
                            <li className={countData.attendance ? 'on' : ''}> {/** 완료 시 on 클래스 추가 */}
                                <div className='content'>
                                    <i></i>펫 먹이주기
                                </div>
                                <div className='info'>X 1</div>
                            </li>
                            <li className={countData.petStargram ? 'on' : ''}>
                                <div className='content'>
                                    <i></i>펫스타그램 좋아요 누르기
                                </div>
                                <div className='info'>X 3</div>
                            </li> 
                            <li className={countData.advertise ? 'on' : ''}>
                                <div className='content'>
                                    <i></i>운세 오픈권 얻기
                                </div>
                                <div className='info'>X 3</div>
                            </li>
                        </ul>
                        <button
                            className='btn lucky'
                            onClick={() => window.GoToFortune()}
                        >
                            btn
                        </button>
                    </div>
                    <div className='event-info progression'>
                        <div className='tit-area'>
                            <h2>빙고판 진척도</h2>
                        </div>
                        <dl className='complete-board'>
                            <dt>완성한 판</dt>
                            <dd>
                                <span>{String(boardCount).padStart(2, '0')}</span>판</dd>
                        </dl>
                        <div className='progress-box'>
                            <div className='progress-area'>
                                {boardData && 
                                    boardData.map((row, index) => (
                                        <dl 
                                            key={index} 
                                            className={stageClass(row.state_cd)}
                                            onClick={() => handleBoardReward(row)}
                                        >
                                            <dt>{row.reward_cn}</dt>
                                            <dd>빙고 {row.standard_cnt} 판</dd>
                                        </dl>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BingoMain;